import { render, staticRenderFns } from "./sprite-compoents.vue?vue&type=template&id=28ec0d01&scoped=true&"
import script from "./sprite-compoents.vue?vue&type=script&lang=js&"
export * from "./sprite-compoents.vue?vue&type=script&lang=js&"
import style0 from "./sprite-compoents.vue?vue&type=style&index=0&id=28ec0d01&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ec0d01",
  null
  
)

export default component.exports